import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatMessageSourcesUtilityClass(slot) {
  return generateUtilityClass('MuiChatMessageSources', slot);
}
export const chatMessageSourcesClasses = generateUtilityClasses('MuiChatMessageSources', ['root', 'label', 'list']);
const slots = {
  root: ['root'],
  label: ['label'],
  list: ['list']
};
export const useChatMessageSourcesUtilityClasses = classes => composeClasses(slots, getChatMessageSourcesUtilityClass, classes);